import { FinancialSettlementAdvancePayment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { protectFeature } from '~libs.shared.system';

import { AdjustmentFormBean } from '../../form/adjustment/adjustment.types';

export const medicalServicesPricesVisitor = (advancePayments: FinancialSettlementAdvancePayment[]) => <ACCEPT>(view: {
   withAdvancePayment: () => ACCEPT;
   withoutAdvancePayment: () => ACCEPT;
}) => {
   if (advancePayments.length) {
      return view.withAdvancePayment();
   }

   return view.withoutAdvancePayment();
};

const adjustmentAvailable = (adjustment: AdjustmentFormBean | undefined): adjustment is AdjustmentFormBean => {
   return Boolean(adjustment);
};

export const isRefundingOnlinePaymentsAvailable = (
   transactionExternalId: string | undefined,
   adjustment?: AdjustmentFormBean
): boolean => {
   const refundingOnlinePaymentsAvailable = protectFeature('refundingOnlinePayments');
   return Boolean(refundingOnlinePaymentsAvailable && transactionExternalId) && !adjustmentAvailable(adjustment);
};

export const amountDueSectionViewVisitor = (amountDue: number) => <ACCEPT>(view: {
   forPositive: () => ACCEPT;
   forNegative: () => ACCEPT;
}) => {
   if (amountDue >= 0) {
      return view.forPositive();
   }

   return view.forNegative();
};
